import _startCase from 'lodash/startCase';
import { Loader } from 'semantic-ui-react';

import ErrMessage from '@components/err-message';
import KeyValueList from '@components/key-value-list';

import { useGetVersionVulnerabilityAnnotationQuery } from '../../applications.api';

export interface VulnerabilityAnnotationDetailsProps {
  annotationId: string;
  appId: string;
  versionId: string;
}

export const VulnerabilityAnnotationDetails = ({
  annotationId,
  appId,
  versionId,
}: VulnerabilityAnnotationDetailsProps) => {
  const {
    currentData: annotation,
    error,
    isError,
    isLoading,
  } = useGetVersionVulnerabilityAnnotationQuery(
    { annotationId, appId, versionId },
    { skip: !annotationId },
  );

  if (isLoading) {
    return <Loader active inline size="medium" />;
  }

  if (isError) {
    return <ErrMessage error={error ?? true} />;
  }

  if (!annotation) {
    return <div>No annotation data found</div>;
  }

  return (
    <KeyValueList
      fullWidthValues
      items={[
        {
          displayName: 'Status',
          key: 'status',
          value: _startCase(annotation.status),
        },
        {
          displayName: 'Status Notes',
          key: 'statusNotes',
          value: annotation.statusNotes || '-',
        },
        {
          displayName: 'Justification',
          key: 'justification',
          show: !!annotation.justification,
          value: annotation.justification
            ? _startCase(annotation.justification)
            : '-',
        },
        {
          displayName: 'Impact Statement',
          key: 'impactStatement',
          show: !!annotation.impactStatement,
          value: annotation.impactStatement || '-',
        },
        {
          displayName: 'Action Statement',
          key: 'actionStatement',
          show: !!annotation.actionStatement,
          value: annotation.actionStatement || '-',
        },
        {
          displayName: 'Additional Details',
          key: 'additionalDetails',
          show: !!annotation.additionalDetails,
          value: annotation.additionalDetails || '-',
        },
      ]}
      labelVerticalAlign="top"
      labelWidthRem={11}
      rightAlignLabels
    />
  );
};

export default VulnerabilityAnnotationDetails;
